export default __webpack_public_path__ + "static/media/Mitchell.594185f3.png";